import { PortfolioBalanceIcon } from 'assets/icons';
import { useTranslation } from 'react-i18next';
import { CheckoutOtp } from 'views/Accounts/components/Checkout.Com/CheckoutOtp';
import { useContext, useMemo, useState } from 'react';
import { AppContext } from 'context/ContextProvider';
import { getPaymentOptions } from 'views/Invest/helpers';
import { HowToPayEnum } from '../HowToPay/type';
import MgmtPaymentTypeSelector, { RadioBtnOption } from '../MgmtFeePolicyEnforcer/mgmtPaymentTypeSelector';

interface ToUpViewParamType {
  portfolioId: number;
  onSuccessUrl?: string;
  onFailureUrl?: string;
  topupAmount: number;
  fxRate: number;
}

const TopUpView = ({ fxRate, portfolioId, topupAmount, onFailureUrl, onSuccessUrl }: ToUpViewParamType) => {
  const {
    formatter,
    state: {
      app: { hasCard },
    },
  } = useContext(AppContext);
  const { t } = useTranslation();

  const [selectedOption, setSelectedOption] = useState<RadioBtnOption | null>();

  const options = useMemo((): RadioBtnOption[] => {
    return getPaymentOptions(hasCard as boolean);
  }, [hasCard]);
  return (
    <div className="bg-white dark:bg-slate-900 h-full">
      {/* Top Up Amount Card */}
      <div className="p-4">
        <div className="bg-gradient-to-br from-gray-50 to-gray-100/80 dark:from-slate-800 dark:to-slate-800/50 rounded-xl p-4 border border-gray-100 dark:border-slate-700/50 shadow-sm dark:shadow-slate-950/30">
          <div className="flex items-center flex-col gap-2">
            <div className="w-10 h-10 rounded-full bg-orange/10 dark:bg-teal-500/15 flex items-center justify-center">
              <PortfolioBalanceIcon className="w-5 h-5 text-orange dark:text-teal-400" />
            </div>
            <span className="text-xs text-gray-500 dark:text-slate-400 uppercase tracking-wide">
              {t('account:slideout.topup.top_up_amount')}
            </span>
            <span className="text-xl font-semibold text-gray-900 dark:text-white">{`${formatter.format(
              topupAmount * (fxRate ?? 1),
              true,
            )}`}</span>
            {(fxRate ?? 1) !== 1 && (
              <>
                <span className="text-base text-gray-600 dark:text-slate-300">{`${formatter.format(
                  topupAmount,
                )}`}</span>
                <div className="mt-2 p-3 bg-amber-50 dark:bg-amber-900/20 rounded-lg border border-amber-200 dark:border-amber-700/50">
                  <span className="text-sm text-amber-800 dark:text-amber-200">
                    <strong className="font-semibold mr-1">{t('common:pleaseNote')}:</strong>
                    {t('common:currency_fxRate_note')}
                  </span>
                </div>
              </>
            )}
          </div>
        </div>
      </div>

      <MgmtPaymentTypeSelector
        onSelected={(selected) => setSelectedOption(selected)}
        options={options}
        selectedId={selectedOption?.id}
      />

      <CheckoutOtp
        showTopUpIcon={false}
        isUseExistingCard={selectedOption?.id === (HowToPayEnum.CARD_ON_FILE as string)}
        amount={topupAmount}
        portfolioId={portfolioId}
        onSuccessUrl={onSuccessUrl}
        onFailureUrl={onFailureUrl}
      />
    </div>
  );
};

export default TopUpView;
